import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'

import InviteFriends from '../components/inviteFriends/InviteFriends'
import { copyToClipBoard } from '../util/app/app.helpers'
import { toast } from 'src/components/shared/snackbar'
import { buildReferralLink } from '../util/inviteFriends.helpers'
import {
  selectAccountProfile,
  selectMainProfile,
  selectReferralProfile,
  selectTokenProfile
} from '../store/selectors/common'
import { getInvites } from '../store/actions/referral'
import { objectById } from '../util/object.helpers'

const InviteFriendsContainer = () => {
  const { t } = useTranslation()

  const mainProfile = useSelector(selectMainProfile)
  const accountProfile = useSelector(selectAccountProfile)
  const tokenProfile = useSelector(selectTokenProfile)
  const referralProfile = useSelector(selectReferralProfile)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getInvites())
  }, [])

  const handleCopyReferral = async () => {
    await copyToClipBoard(buildReferralLink(accountProfile.authId))
    toast.success(t('referral.copied-referral-link'))
  }

  return (
    <InviteFriends
      t={t}
      onCopyReferral={handleCopyReferral}
      userTier={mainProfile.userTier}
      tiers={objectById(mainProfile.tiers)}
      symbol={tokenProfile.symbol}
      referralProfile={referralProfile}
      authId={accountProfile.authId}
    />
  )
}

export default InviteFriendsContainer
